import { render, staticRenderFns } from "./ReportBeneficiarios.vue?vue&type=template&id=ca2c42aa&scoped=true"
import script from "./ReportBeneficiarios.vue?vue&type=script&lang=js"
export * from "./ReportBeneficiarios.vue?vue&type=script&lang=js"
import style0 from "./ReportBeneficiarios.vue?vue&type=style&index=0&id=ca2c42aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca2c42aa",
  null
  
)

export default component.exports